<template>
    <div class="barContainer row"  style="margin-bottom: 2em;">
        <div class="small-2 text-center columns">
            <img class="barContainer__icon"
                :src="'/themes/nutristopa/assets/img/' + label + '.png'"
                 v-tooltip.bottom="{ content: description }"
            >
        </div>
        <div class="columns" :class="[isNutrition ? 'small-7' : 'small-8']">

            <a class="bar"
               v-for="(value, key, index) in indicatorShares"
               :style="{'width': (value + '%')}"
               :class="('color' + index)"
               v-tooltip.bottom="{ content: key +': ' + Math.round(value * 100) / 100 + ' %' }"
            >
                &nbsp;
            </a>
        </div>
        <div class="small-2 columns">
            <indicator-result
                v-show="isNutrition"
                :value="indicatorValue"
                :indicator="label"
                :showIcon="false"
                v-tooltip.bottom="{content: 'Vztažení hodnoty k doporučeným dávkám (DDD) je vyjádřeno procenty v kruhu vpravo.'}"
            ></indicator-result>
            <indicator-result
                    v-show="!isNutrition"
                    :value="indicatorValue"
                    :indicator="label"
                    :showIcon="false"
                    v-tooltip.bottom="{content: 'Závažnost celkového dopadu je vyjádřena v koláčovém grafu výše.'}"
            ></indicator-result>
        </div>
        <div class="small-1 columns" v-show="isNutrition">
            <a v-tooltip.bottom="{ content: intakeRecommendation, classes: ['tooltip-wider']}">
                <div class="dailyRecommendedIntake">
                    {{ shareOfRecommendedIntake }} %
                    <span>DDD</span>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    import IndicatorResult from '../components/indicatorResult'

    let descriptions = {
        climate: 'Sloupce ukazují <strong>podíl jednotlivých ingrediencí a přípravy na množství vyprodukovaných emisí skleníkových plynů (tj. příspěvek ke změně klimatu)</strong> z celkového dopadu na 1 porci pokrmu.',
        acidification: 'Sloupce ukazují <strong>podíl jednotlivých ingrediencí a přípravy na množství látek způsobujících okyselování půdy</strong> z celkového dopadu na 1 porci pokrmu.',
        euthropication: 'Sloupce ukazují <strong>podíl jednotlivých ingrediencí a přípravy na množství látek způsobujících eutrofizaci vody (tj. nadbytek fosforu či dusíku ve sladké vodě)</strong> z celkového dopadu na 1 porci pokrmu.',
        occupation: 'Sloupce ukazují <strong>podíl jednotlivých ingrediencí a přípravy na záboru půdy</strong> z celkového záboru na 1 porci pokrmu.',
        water: 'Sloupce ukazují <strong>podíl jednotlivých ingrediencí a přípravy na spotřebu vody</strong> z celkové spotřeby na 1 porci pokrmu.',
        energy: 'Sloupce ukazují <strong>podíl energetického obsahu jednotlivých ingrediencí</strong> z celkového obsahu energie na 1 porci pokrmu.',
        fat: 'Sloupce ukazují <strong>podíl tuku v jednotlivých ingrediencích</strong> z celkového obsahu tuku na 1 porci pokrmu.',
        fattyacids: 'Sloupce ukazují <strong>podíl nasycených mastných kyselin (obsažených zejména v živočišných tucích) v jednotlivých ingrediencích</strong> z celkového obsahu nasysených mastných kyselin na 1 porci pokrmu.',
        sugar: 'Sloupce ukazují <strong>podíl cukru (tzv. volných cukrů nikoli polysacharidů) v jednotlivých ingrediencích</strong> z celkového obsahu cukru na 1 porci pokrmu.',
        salt: 'Sloupce ukazují <strong>podíl soli v jednotlivých ingrediencích</strong> z celkového obsahu soli na 1 porci pokrmu.'
    };

    let intakeRecommendations = {
        energy: 'Číslo ukazuje jaký <strong>podíl energie</strong> je obsažen v jedné porci pokrmu <strong>ve vztahu k denní výživové doporučené dávce</strong> (DDD). Referenční hodnota pro dospělou ženu je 2800 kJ/den. <strong>Oběd by měl pokrýt zhuba 35% DDD</strong>. Pokud je hodnota u receptu výrazně vyšší, hlídejte si příjem energie z ostatních jídel a hlavně celkově ve svém jídelníčku. <strong>Příjem energie z potravin by měl být v rovnováze s výdejem energie.</strong>',
        fat: 'Číslo ukazuje jaký <strong>podíl tuků</strong> je obsažen v jedné porci pokrmu <strong>ve vztahu k denní výživové doporučené dávce</strong> (DDD). Referenční hodnota pro dospělou ženu je 70 g/den. <strong>Oběd by měl pokrýt zhruba max. 35% DDD</strong>. Pokud je hodnota u receptu výrazně vyšší, hlídejte si příjem tuků z ostatních jídel a hlavně celkově ve svém jídelníčku. <strong>Příjem určitého množství tuků je v pestré stravě žádaný, ale kontrolujte také jaké tuky a v jakém celkovém množství konzumujete</strong>.',
        fattyacids: 'Číslo ukazuje jaký <strong>podíl nasycených mastných kyselin (NMK)</strong> je obsažen v jedné porci pokrmu <strong>ve vztahu k denní výživové doporučené dávce</strong> (DDD). Referenční hodnota pro dospělou ženu je 20 g/den. <strong>Oběd by měl pokrýt zhruba max. 35% DDD</strong>. Pokud je hodnota u receptu výrazně vyšší, hlídejte si příjem NMK z ostatních jídel a hlavně celkově ve svém jídelníčku (jsou ve větším množství obsaženy zejména v živočišných tucích - máslo, sádlo - ale také v některých rostlinných tucích - palmový, kokosový). <strong>Příjem určitého množství NMK je v pestré stravě žádaný, ale kontrolujte jaké celkové množství konzumujete v poměru s příhodnějšími tuky nenasycenými</strong> (jsou obsaženy zejména v olejích - řepkový, slunečnicový, olivový, atp.).',
        sugar: 'Číslo ukazuje jaký <strong>podíl cukrů (tzv. volných cukrů)</strong> je obsažen v jedné porci pokrmu <strong>ve vztahu k denní výživové doporučené dávce</strong> (DDD). Referenční hodnota pro dospělou ženu je 90 g/den. <strong>Oběd by měl pokrýt zhruba max. 35% DDD</strong>. Pokud je hodnota u receptu výrazně vyšší, hlídejte si příjem cukrů z ostatních jídel a hlavně celkově ve svém jídelníčku. <strong>Příjem určitého množství cukrů je v pestré stravě žádaný, ale zejména přirozeně se vyskytujícího cukru (např. v ovoci a zelenině) oproti cukru přidanému (např. ve sladkostech)</strong>.',
        salt: 'Číslo ukazuje jaký <strong>podíl soli</strong> je obsažen v jedné porci pokrmu <strong>ve vztahu k denní výživové doporučené dávce</strong> (DDD). Referenční hodnota pro dospělou ženu je max. 6 g/den. <strong>Oběd by měl pokrýt zhruba max. 35% DDD</strong>. Pokud je hodnota u receptu výrazně vyšší, hlídejte si příjem soli z ostatních jídel a hlavně celkově ve svém jídelníčku. <strong>Příjem dodané soli by měl být ve stravě omezen na minimum.</strong>'
    };

    export default {

        components: {
            IndicatorResult
        },

        props: [
            'indicatorShares',
            'label',
            'indicatorValue',
            'shareOfRecommendedIntake'
        ],

        computed: {
            isNutrition() {
                return typeof (this.shareOfRecommendedIntake) !== 'undefined';
            },

            description() {
                return descriptions[this.label];
            },

            intakeRecommendation() {
                return intakeRecommendations[this.label];
            }
        }
    }
</script>

<style>
    .dailyRecommendedIntake {
        background-color: #DD616B;
        padding: 0.4em 0.3em 0.2em 0.3em;
        border-radius: 50%;
        color: white;
        text-align: center;
        font-weight: bold;
        cursor: help;
    }

    .dailyRecommendedIntake span {
        font-size: 0.8em;
        font-weight: normal;
    }
</style>